export const CLOSE_ADDFUNDS = 'golagol/addfunds/actions/close';
export const OPEN_ADDFUNDS = 'golagol/addfunds/actions/open';

export const ADDFUNDS_IS_OPEN = 'golagol/addfunds/getters/open';
